import { Injectable } from '@angular/core';

@Injectable()
export class OfflineService {
    getId(key): number{
        let id = Number(localStorage.getItem(key)) || 1;
        id += 1;
        localStorage.setItem(key, id + "");
        return id;
    }
}

export enum TouKeys{
    Team = "Team",
    Tournament = "Tournament",
    Player = "Player",
    GamePair = "Gamepair"
}



// WEBPACK FOOTER //
// /src/pages/apps/gamer/services/offline.service.ts